import { render, staticRenderFns } from "./RegionGeneralSettingsForm.vue?vue&type=template&id=7af0819e&"
import script from "./RegionGeneralSettingsForm.vue?vue&type=script&lang=js&"
export * from "./RegionGeneralSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports